export const enum AuthModalType {
  AUTH = 'auth',
  BOT_AUTH = 'bot-auth',
  REPORT = 'report',
}
